<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-12-10 16:40:25
-->
<template>
  <div class="background-contain">
    <div class="page-contain">
      <div class="body">
        <div class="right-contain">
          <div class="right-contain-tip1">Apexis</div>
          <div class="right-contain-tip1">{{ $t("components.firstPart.462772-0") }} {{ $t("components.firstPart.462772-1") }} {{ $t("components.firstPart.462772-2") }}</div>
          <div class="right-contain-tip2">{{ $t("components.firstPart.462772-3") }}</div>

          <!-- 移动端显示图片 -->
          <div class="phone-right-img"></div>
          <div class="phone-down-contain">
            <div slot="reference" class="right-contain-tip3" @click="toDownload(2)">
              <img src="@/assets/ios-icon02.png" class="btn-icon" alt="" />
              <!-- <img v-else src="@/assets/ios-icon01.png" class="btn-icon" alt="" /> -->
              <div class="ios-btn">
                <div class="ios-title1">Download on the</div>
                <div class="ios-title2">App Store</div>
              </div>
            </div>
            <!-- <div slot="reference" class="right-contain-tip4 and-btn" @click="toDownload(1)">
              <img src="../assets/goo@2x.png" alt="" />
              <div class="btn-text">
                <div class="ios-tip01">GET IT ON</div>
                <div class="ios-tip02">GOOGLE PLAY</div>
              </div>
            </div> -->
            <div slot="reference" class="right-contain-tip4 and-btn" @click="toDownload(3)">
              <!-- 敬请期待 -->
              <div class="and-btn">
                <img class="btn-icon" style="width: 24px; height: 24px; margin-right: 6px" src="../assets/down.png" alt="" />
                <div class="btn-text">{{ $t("components.firstPart.462772-4") }}</div>
              </div>
            </div>
          </div>

          <div class="down-contain">
            <el-popover placement="bottom" title="" trigger="hover" content="" popper-class="poppers" @show="acitve = 1" @hide="acitve = 0" :disabled="env != 'production'">
              <div slot="reference" class="right-contain-tip3" :class="acitve == 1 ? 'hover1' : ''" @click="toDownload(2)">
                <img src="@/assets/ios-icon02.png" class="btn-icon" alt="" />
                <!-- <img src="@/assets/ios-icon01.png" class="btn-icon" alt="" /> -->
                <div class="ios-btn">
                  <div class="ios-title1">Download on the</div>
                  <div class="ios-title2">App Store</div>
                </div>
              </div>
              <img style="width: 150px; height: 150px" src="@/assets/code-ios.png" alt="" />
            </el-popover>
            <!-- <el-popover placement="bottom" title="" trigger="hover" content="" @show="acitve = 2" popper-class="poppers" :disabled="env != 'production'">
              <div slot="reference" class="right-contain-tip4" :class="acitve == 2 ? 'hover2' : ''" @click="toDownload(1)">
                <img src="../assets/goo@2x.png" class="btn-icon" style="width: 24px; height: 24px" alt="" />
                <div class="ios-btn">
                  <div class="ios-tip01">GET IT ON</div>
                  <div class="ios-tip02">GOOGLE PLAY</div>
                </div>
              </div>
              <img style="width: 150px; height: 150px" src="@/assets/code-android.png" alt="" />
            </el-popover> -->
            <el-popover placement="bottom" title="" trigger="hover" content="" @show="acitve = 3" @hide="acitve = 0" popper-class="poppers" :disabled="env != 'production'">
              <div slot="reference" class="right-contain-tip4" style="margin-left: 16px" :class="acitve == 3 ? 'hover2' : ''" @click="toDownload(3)">
                <!-- <img v-if="acitve == 1" src="@/assets/anz-icon01.png" class="btn-icon" alt="" />
                <img v-else src="@/assets/anz-icon02.png" class="btn-icon" alt="" /> -->
                <!-- <img v-if="acitve == 3" src="../assets/down2.png" class="btn-icon" alt="" /> -->
                <img src="../assets/down.png" class="btn-icon" alt="" />

                {{ $t("components.firstPart.462772-4") }}
              </div>
              <img style="width: 150px; height: 150px" src="@/assets/apk.png" alt="" />
            </el-popover>
          </div>
        </div>
        <div class="right-img"></div>
      </div>
      <div class="footer">
        <div class="footer-title">{{ $t("components.firstPart.462772-5") }}</div>
        <div class="img-contain">
          <img class="pc-img" src="@/assets/icons.jpg" alt="" />
          <img class="phone-img" src="@/assets/pnone-icons.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "firstPart",
  props: {
    msg: String,
  },
  data() {
    return {
      acitve: 0,
      env: process.env.NODE_ENV,
    };
  },
  methods: {
    toDownload(type) {
      // console.log(process.env.VUE_APP_DOWNLOAD_URl);
      console.log(process.env);
      // console.log(type);
      if (type == 1) {
        // 谷歌
        if (process.env.NODE_ENV == "production") location.href = "https://play.google.com/store/apps/details?id=com.bytelink.cregispay.card";
      } else if (type == 2) {
        // 苹果
        if (process.env.NODE_ENV == "production") location.href = "https://www.pgyer.com/apexisceshi";
      } else {
        if (process.env.NODE_ENV == "production") {
          location.href = "https://file.vcard-usa.com/app/apexis.apk";
        } else {
          location.href = "https://file.vcard-usa.com/app/apexis.apk";
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-popover .el-popper .poppers {
  min-width: 135px !important;
  width: 135px !important;
  padding: 0;
}
</style>
<style src="./firstPartCss/max.css" scoped></style>
<style src="./firstPartCss/middle.css" scoped></style>
<style src="./firstPartCss/flat.css" scoped></style>
<style src="./firstPartCss/min.css" scoped></style>
